<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-route-calendar">
        <div class="modal-header">
            <h3 class="mb-0">{{ 'aimo.orderhistory.reorder' | cxTranslate }}</h3>
            <div class="modal-action col-auto">
                <button #closeButton class="btn-link" [attr.aria-label]="'aimo.arialLabel.close.modal' | cxTranslate">
                    <i class="aimo-icon icon-inline icon-x" (click)="closeDialog()"></i>
                </button>
            </div>
        </div>
        <div class="modal-body">
            <p>{{ 'aimo.orderhistory.reorderDescription' | cxTranslate }}</p>

            <aimo-cx-delivery-date-component
                [modal]="true"
                [allowPastDates]="false"
                [autofocus]="true"
                (dayClicked)="selectDate($event)"
                [calendarSource]="calendarSource">
            </aimo-cx-delivery-date-component>

            <div class="modal-actions flex-start">
                <button class="btn btn-primary btn-sm btn-inline mr-2" (click)="submit()">
                    {{ 'aimo.orderhistory.selectDate' | cxTranslate }}
                </button>
                <button
                    class="btn btn-secondary btn-sm btn-inline"
                    (keydown.tab)="getTheFocusBack($event)"
                    (click)="closeDialog()">
                    {{ 'aimo.orderhistory.cancel' | cxTranslate }}
                </button>
            </div>
        </div>
    </div>
</div>
